module.exports = __webpack_public_path__ + "img/btn.13bc28b0.png";